module.exports = __webpack_public_path__ + "static/bg-gandd-402adb0d39ca888b1910e345bdaae467.webp";